<div class="flex">
  <div class="mr-5">
    <ul>
      <li (click)="scroll(Forms)" class="mb-2">Forms</li>
      <ul>
        <li (click)="scroll(InputText)" class="mb-2">InputText</li>
        <li (click)="scroll(HelperText)" class="mb-2">HelperText</li>
        <li (click)="scroll(Textarea)" class="mb-2">Textarea</li>
        <li (click)="scroll(Icons)" class="mb-2">Icons</li>
        <li (click)="scroll(Password)" class="mb-2">Password</li>
        <li (click)="scroll(AutoComplete)" class="mb-2">AutoComplete</li>
        <li (click)="scroll(InputNumber)" class="mb-2">InputNumber</li>
        <li (click)="scroll(InputDecimal)" class="mb-2">InputDecimal</li>
        <li (click)="scroll(Chips)" class="mb-2">Chips</li>
        <li (click)="scroll(RadioButton)" class="mb-2">RadioButton</li>
        <li (click)="scroll(Checkbox)" class="mb-2">Checkbox</li>
        <li (click)="scroll(Listbox)" class="mb-2">Listbox</li>
        <li (click)="scroll(ToggleButton)" class="mb-2">ToggleButton</li>
      </ul>
      <li (click)="scroll(Buttons)" class="mb-2">Buttons</li>
      <li (click)="scroll(Data)" class="mb-2">Data</li>
      <ul>
        <li (click)="scroll(Timeline)" class="mb-2">Timeline</li>
      </ul>
      <li (click)="scroll(Panels)" class="mb-2">Panels</li>
      <ul>
        <li (click)="scroll(AccordionPanel)" class="mb-2">AccordionPanel</li>
        <li (click)="scroll(TabView)" class="mb-2">TabView</li>
      </ul>
      <li (click)="scroll(Overlay)" class="mb-2">Overlay</li>
      <ul>
        <li (click)="scroll(Dialog)" class="mb-2">Dialog</li>
      </ul>
      <li class="mb-2">Messages</li>
      <ul>
        <li (click)="scroll(Messages)" class="mb-2">Messages</li>
        <li (click)="scroll(Toast)" class="mb-2">Toast</li>
      </ul>
      <li (click)="scroll(Menu)" class="mb-2">Menu</li>
    </ul>
  </div>
  <div>
    <p-card styleClass="mb-4 p-fluid">
      <h2 #Forms>Forms</h2>
      <hr />
      <h3 #InputText>InputText</h3>
      <div class="grid formgrid">
        <div class="col-12 mb-2 lg:col-4 lg:mb-0">
          <input pInputText type="text" placeholder="Default" />
        </div>
        <div class="col-12 mb-2 lg:col-4 lg:mb-0">
          <input pInputText type="text" placeholder="Disabled" [disabled]="true" />
        </div>
        <div class="col-12 mb-2 lg:col-4 lg:mb-0">
          <input pInputText type="text" placeholder="Invalid" class="ng-invalid ng-dirty" />
        </div>
      </div>

      <h3 #HelperText>Helper Text</h3>
      <label for="username2">Username</label>
      <input pInputText id="username2" type="text" class="ng-invalid ng-dirty" aria-describedby="username-help" />
      <small id="username-help" class="p-error">Enter your username to reset your password.</small>

      <h3 #Textarea>Textarea</h3>
      <textarea pInputTextarea placeholder="Your Message" [autoResize]="false" rows="3" cols="30"></textarea>

      <h3 #Icons>Icons</h3>
      <div class="grid formgrid">
        <div class="col-12 mb-2 lg:col-4 lg:mb-0">
          <span class="p-input-icon-left">
            <i class="pi pi-user"></i>
            <input pInputText type="text" placeholder="Username" />
          </span>
        </div>
        <div class="col-12 mb-2 lg:col-4 lg:mb-0">
          <span class="p-input-icon-right">
            <input pInputText type="text" placeholder="Search" />
            <i class="pi pi-search"></i>
          </span>
        </div>
        <div class="col-12 mb-2 lg:col-4 lg:mb-0">
          <span class="p-input-icon-left p-input-icon-right">
            <i class="pi pi-user"></i>
            <input pInputText type="text" placeholder="Search" />
            <i class="pi pi-search"></i>
          </span>
        </div>
      </div>

      <h3 #Password>Password</h3>
      <p-password [(ngModel)]="passwordValue" [toggleMask]="true" [feedback]="true">
        <ng-template pTemplate="content">
          <div class="p4 px-2">
            <p class="p4 font-medium mt-3 mb-2 ml-2">Requirements</p>
            <ul class="p4 mt-0" style="line-height: 1.5">
              <li>Minimum 8 characters</li>
              <li>At least one lowercase</li>
              <li>At least one uppercase</li>
              <li>At least one numeric</li>
              <li>At least one symbol</li>
            </ul>
          </div>
        </ng-template>
      </p-password>

      <h3 #AutoComplete>AutoComplete</h3>
      <p-autoComplete
        [(ngModel)]="selectedCountry"
        [suggestions]="filteredCountries"
        (completeMethod)="filterCountry($event)"
        field="name"
        [minLength]="1"
      ></p-autoComplete>

      <h3 #Calendar>Calendar</h3>
      <p-calendar [showIcon]="true" [showButtonBar]="true" [(ngModel)]="calendarValue"></p-calendar>

      <h3 #InputNumber>InputNumber</h3>
      <p-inputNumber id="input-number" [(ngModel)]="inputNumberValue" [useGrouping]="false"></p-inputNumber>

      <h3 #InputDecimal>InputDecimal</h3>
      <p-inputNumber
        id="input-decimal"
        [(ngModel)]="inputDecimalValue"
        mode="decimal"
        [minFractionDigits]="1"
        [maxFractionDigits]="2"
        [useGrouping]="false"
      ></p-inputNumber>

      <h3 #Chips>Chips</h3>
      <p-chips [(ngModel)]="chipsValue"></p-chips>

      <h3 #RadioButton>RadioButton</h3>
      <div class="grid">
        <div class="col-12 md:col-4">
          <div class="field-radiobutton">
            <p-radioButton inputId="option1" name="option" value="Option 1" [(ngModel)]="radioValue"></p-radioButton>
            <label for="option1">Option 1</label>
          </div>
        </div>
        <div class="col-12 md:col-4">
          <div class="field-radiobutton">
            <p-radioButton inputId="option2" name="option" value="Option 2" [(ngModel)]="radioValue"></p-radioButton>
            <label for="option2">Option 2</label>
          </div>
        </div>
        <div class="col-12 md:col-4">
          <div class="field-radiobutton">
            <p-radioButton inputId="option3" name="option" value="Option 3" [(ngModel)]="radioValue"></p-radioButton>
            <label for="option3">Option 3</label>
          </div>
        </div>
      </div>

      <h3 #Checkbox>Checkbox</h3>
      <div class="grid">
        <div class="col-12 md:col-4">
          <div class="field-checkbox">
            <p-checkbox inputId="checkOption1" name="option" value="Option 1" [(ngModel)]="checkboxValue"></p-checkbox>
            <label for="checkOption1">Option 1</label>
          </div>
        </div>
        <div class="col-12 md:col-4">
          <div class="field-checkbox">
            <p-checkbox inputId="checkOption2" name="option" value="Option 2" [(ngModel)]="checkboxValue"></p-checkbox>
            <label for="checkOption2">Option 2</label>
          </div>
        </div>
        <div class="col-12 md:col-4">
          <div class="field-checkbox">
            <p-checkbox inputId="checkOption3" name="option" value="Option 3" [(ngModel)]="checkboxValue"></p-checkbox>
            <label for="checkOption3">Option 3</label>
          </div>
        </div>
      </div>

      <h3 #Listbox>Listbox</h3>
      <p-listbox
        [options]="cities"
        [(ngModel)]="listboxValue"
        optionLabel="name"
        [checkbox]="true"
        [filter]="true"
        [multiple]="true"
      ></p-listbox>

      <h3>Dropdown</h3>
      <p-dropdown [options]="cities" [(ngModel)]="dropdownValue" optionLabel="name" placeholder="Select"></p-dropdown>

      <h3>MultiSelect</h3>
      <p-multiSelect
        [options]="multiselectOptions"
        [filter]="false"
        [(ngModel)]="multiselectValue"
        placeholder="Select"
        optionLabel="name"
        display="chip"
      ></p-multiSelect>

      <h3 #ToggleButton>ToggleButton</h3>
      <p-toggleButton [(ngModel)]="toggleValue" onLabel="Yes" offLabel="No"></p-toggleButton>

      <h3>SelectButton</h3>
      <p-selectButton
        [(ngModel)]="selectButtonValue1"
        [options]="selectButtonOptions"
        optionLabel="name"
      ></p-selectButton>

      <h3>SelectButton - Multiple</h3>
      <p-selectButton
        [(ngModel)]="selectButtonValue2"
        [options]="selectButtonOptions"
        optionLabel="name"
        [multiple]="true"
      ></p-selectButton>
    </p-card>
    <p-card styleClass="mb-4">
      <h2>Buttons</h2>
      <hr />

      <h3 #Buttons>Buttons</h3>
      <button type="button" pButton label="Submit" class="mr-2 mb-2"></button>

      <h3>Severities</h3>
      <button type="button" pButton label="Primary" class="mr-2 mb-2"></button>

      <h3>Raised Buttons</h3>
      <button type="button" pButton label="Primary" class="p-button-raised mr-2 mb-2"></button>

      <h3>Rounded Buttons</h3>
      <button type="button" pButton label="Primary" class="p-button-rounded mr-2 mb-2"></button>

      <h3>Text Buttons</h3>
      <button type="button" pButton label="Primary" class="p-button-text mr-2 mb-2"></button>
      <button type="button" pButton label="Disabled" class="p-button-text mr-2 mb-2" disabled></button>

      <h3>Outlined Buttons</h3>
      <button type="button" pButton label="Primary" class="p-button-outlined mr-2 mb-2"></button>
      <button type="button" pButton label="Disabled" class="p-button-outlined mr-2 mb-2" disabled></button>

      <h3>Rounded Icon Buttons</h3>
      <button type="button" pButton icon="pi pi-check" class="p-button-rounded mr-2 mb-2"></button>

      <h3>Rounded Text Icon Buttons</h3>
      <button type="button" pButton icon="pi pi-check" class="p-button-rounded p-button-text mr-2 mb-2"></button>

      <h3>Rounded and Outlined Icon Buttons</h3>
      <button type="button" pButton icon="pi pi-check" class="p-button-rounded p-button-outlined mr-2 mb-2"></button>
    </p-card>

    <p-card styleClass="mb-4">
      <h2 #Panels>Panels</h2>
      <hr />
      <h3 #AccordionPanel>AccordionPanel</h3>
      <p-accordion>
        <p-accordionTab header="Header I" [selected]="true">
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex
            ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat
            nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit
            anim id est laborum.
          </p>
        </p-accordionTab>
        <p-accordionTab header="Header II">
          <p>
            Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem
            aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.
            Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni
            dolores eos qui ratione voluptatem sequi nesciunt. Consectetur, adipisci velit, sed quia non numquam eius
            modi.
          </p>
        </p-accordionTab>
        <p-accordionTab header="Header III">
          <p>
            At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti
            atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique
            sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum
            facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil
            impedit quo minus.
          </p>
        </p-accordionTab>
      </p-accordion>

      <h3 #TabView>TabView</h3>
      <p-tabView>
        <p-tabPanel header="Header I">
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex
            ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat
            nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit
            anim id est laborum.
          </p>
        </p-tabPanel>
        <p-tabPanel header="Header II">
          <p>
            Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem
            aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.
            Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni
            dolores eos qui ratione voluptatem sequi nesciunt. Consectetur, adipisci velit, sed quia non numquam eius
            modi.
          </p>
        </p-tabPanel>
        <p-tabPanel header="Header III">
          <p>
            At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti
            atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique
            sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum
            facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil
            impedit quo minus.
          </p>
        </p-tabPanel>
      </p-tabView>
    </p-card>

    <p-card styleClass="mb-4">
      <h2 #Data>Data</h2>
      <hr />
      <h3 #Timeline>Timeline</h3>
      <p-timeline [value]="events">
        <ng-template pTemplate="content" let-events>
          {{ events.status }}
        </ng-template>
      </p-timeline>
    </p-card>

    <p-card class="p-fluid" styleClass="mb-4">
      <h2 #Overlay>Overlay</h2>
      <hr />
      <h3 #Dialog>Dialog</h3>
      <p-dialog header="Dialog" [(visible)]="displayDialog" [style]="{ width: '50vw' }" [modal]="true">
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
          magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
          consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
          est laborum.
        </p>
        <ng-template pTemplate="footer">
          <button pButton label="Dismiss" (click)="closeDialog()" icon="pi pi-check" class="p-button-text"></button>
        </ng-template>
      </p-dialog>
      <button pButton label="Show" icon="pi pi-external-link" class="p-button" (click)="openDialog()"></button>
    </p-card>

    <p-card styleClass="mb-4">
      <h3 #Messages>Messages</h3>

      <p-messages [(value)]="msgs" [enableService]="false"></p-messages>

      <h3 #Toast>Toast</h3>

      <button pButton (click)="showToast('info')" label="Info" class="p-button-info mr-2 mb-2"></button>
      <button pButton (click)="showToast('success')" label="Success" class="p-button-success mr-2 mb-2"></button>
      <button pButton (click)="showToast('warn')" label="Warn" class="p-button-warning mr-2 mb-2"></button>
      <button pButton (click)="showToast('error')" label="Error" class="p-button-danger mb-2"></button>
    </p-card>
  </div>
</div>
<p-card class="p-card-w-title p-fluid" styleClass="mb-4">
  <h3 #Menu>Menubar</h3>
  <p-menubar [model]="tieredMenuItems">
    <ng-template pTemplate="end">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input type="text" pInputText placeholder="Search" />
      </span>
    </ng-template>
  </p-menubar>
</p-card>
